function whenSplideReady(callback, attempt = 0) {
  if (typeof window.Splide === 'function') return callback()
  if (attempt > 50) return
  requestAnimationFrame(() => whenSplideReady(callback, attempt + 1))
}

function setCarouselCarets(root) {
  const prevTemplate = root.querySelector('[data-carousel-caret-prev]')
  const nextTemplate = root.querySelector('[data-carousel-caret-next]')
  const prev = root.querySelector('[data-main-carousel] .splide__arrow--prev')
  const next = root.querySelector('[data-main-carousel] .splide__arrow--next')

  if (prev && prevTemplate) prev.innerHTML = prevTemplate.innerHTML
  if (next && nextTemplate) next.innerHTML = nextTemplate.innerHTML
}

function initMediaCarouselRoot(root) {
  const SplideCtor = window.Splide
  if (!root || root.dataset.initialized === 'true' || typeof SplideCtor !== 'function') return
  if (root.dataset.mediaInitPending === 'true') return

  const mainEl = root.querySelector('[data-main-carousel]')
  if (!mainEl) return

  root.dataset.mediaInitPending = 'true'

  try {
    const thumbsEl = root.querySelector('[data-thumb-carousel]')
    const enableLoop = root.dataset.enableLoop !== 'false'
    const showArrows = root.dataset.showArrows !== 'false'

    const main = new SplideCtor(mainEl, {
      type: enableLoop ? 'loop' : 'slide',
      rewind: !enableLoop,
      arrows: showArrows,
      pagination: false,
      gap: 0,
    })

    if (thumbsEl) {
      const thumbs = new SplideCtor(thumbsEl, {
        fixedWidth: 72,
        fixedHeight: 72,
        gap: '8px',
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: false,
        cover: true,
        breakpoints: {
          640: {
            fixedWidth: 56,
            fixedHeight: 56,
          },
        },
      })

      main.sync(thumbs)
      main.mount()
      thumbs.mount()
      root._mainProductThumbSplide = thumbs
    } else {
      main.mount()
    }

    setCarouselCarets(root)
    root.dataset.initialized = 'true'
    root._mainProductMediaSplide = main
  } finally {
    delete root.dataset.mediaInitPending
  }
}

function initMediaCarousels(scope = document) {
  whenSplideReady(() => {
    scope.querySelectorAll('[data-main-product-carousel]').forEach(initMediaCarouselRoot)
  })
}

const BOTTLE_PRICE_SYNC_EVENT = 'request-bottle-price-sync'

window.addEventListener(BOTTLE_PRICE_SYNC_EVENT, () => {
  document.querySelectorAll('bottle-selector').forEach((selector) => {
    if (typeof selector.sync === 'function') selector.sync()
  })
})

class BottleSelector extends HTMLElement {
  connectedCallback() {
    this.onPurchaseTypeChange = this.onPurchaseTypeChange.bind(this)
    this.addEventListener('change', this.onChange)
    document.addEventListener('skio::update-selling-plan', this.onPurchaseTypeChange)
    this.sync()
  }

  disconnectedCallback() {
    document.removeEventListener('skio::update-selling-plan', this.onPurchaseTypeChange)
  }

  onChange() {
    this.sync()
  }

  onPurchaseTypeChange(event) {
    const section = this.closest('[data-section]')
    if (!section || !section.contains(event.target)) return
    this.sync(event)
  }

  detectPurchaseMode() {
    const section = this.closest('[data-section]')
    const input = section?.querySelector('input[name="selling_plan"]')
    return Boolean(input?.value)
  }

  updateDisplay(isSubscription) {
    this.querySelectorAll('[data-bottle-card]').forEach((card) => {
      const title = isSubscription ? card.dataset.subscriptionTitle : card.dataset.onetimeTitle
      const capsule = isSubscription ? card.dataset.subscriptionCapsule : card.dataset.onetimeCapsule
      const imageUrl = isSubscription
        ? card.dataset.subscriptionImage || card.dataset.onetimeImage
        : card.dataset.onetimeImage

      const titleEl = card.querySelector('[data-bottle-title]')
      if (titleEl && title) titleEl.textContent = title

      const imageEl = card.querySelector('[data-bottle-image]')
      if (imageEl && imageUrl) {
        imageEl.src = imageUrl
        imageEl.removeAttribute('srcset')
        if (title) imageEl.alt = title
      }

      const capsuleEl = card.querySelector('[data-bottle-capsule]')
      if (!capsuleEl) return

      if (capsule) {
        capsuleEl.textContent = `(${capsule})`
        capsuleEl.classList.remove('hidden')
      } else {
        capsuleEl.textContent = ''
        capsuleEl.classList.add('hidden')
      }
    })
  }

  sync(skioEvent = null) {
    const selected = this.querySelector("input[type='radio']:checked")
    if (!selected) return

    const isSubscription =
      skioEvent != null
        ? Boolean(skioEvent.detail?.sellingPlan)
        : this.detectPurchaseMode()
    const quantity = isSubscription
      ? selected.dataset.subscriptionQuantity
      : selected.dataset.onetimeQuantity

    const quantityInput = document.querySelector(`[data-bottle-quantity="${this.dataset.sectionId}"]`)
    if (quantityInput) {
      quantityInput.value = quantity
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }))
    }

    this.updateDisplay(isSubscription)

    window.dispatchEvent(
      new CustomEvent('update-price', {
        detail: {
          sectionId: this.dataset.sectionId,
          variantId: selected.dataset.variantId,
          oneTimePrice: selected.dataset.oneTimePrice,
          subscriptionPrice: selected.dataset.subscriptionPrice,
          quantity,
          subscriptionBadge: selected.dataset.subscriptionBadge,
        },
      })
    )
  }
}

if (!customElements.get('bottle-selector')) {
  customElements.define('bottle-selector', BottleSelector)
}

function bootMainProduct() {
  initMediaCarousels()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootMainProduct)
} else {
  bootMainProduct()
}

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target?.querySelector('[data-main-product-carousel]')) return
  initMediaCarousels(event.target)
})
